/**
 * User Avatar Form Logic
 *
 * Views: users/edit
 */

if ($('#app-user-avatar-form').length > 0) {
    $(document).ready(function () {
        var Cropper = window.Cropper;
        var URL = window.URL || window.webkitURL;
        var uploadedImageURL;

        var options = {
            aspectRatio: 1,
            viewMode: 0,
            dragMode: 'move',
            autoCropArea: 1
        };

        var cropper = new Cropper(document.getElementById('avatar'), options);

        $('.cropper-image').each(function (index, value) {
            if ($(value).hasClass('empty')) {
                $(value).closest('.avatar-container')
                    .find('button[data-method="zoom-out"], button[data-method="zoom-in"], button[data-method="save"], button[data-method="preview"]')
                    .attr('disabled', 'disabled');
            }
        });

        $('.avatar-upload').on('change', function () {
            var files = this.files;
            var file;

            var container = $(this).closest('.avatar-container');
            var type = container.attr('data-id');


            if (cropper && files && files.length) {
                file = files[0];

                if (/^image\/\w+/.test(file.type)) {
                    if (uploadedImageURL) {
                        URL.revokeObjectURL(uploadedImageURL);
                    }

                    var image = document.getElementById(container.find('img').attr('id'));

                    image.src = uploadedImageURL = URL.createObjectURL(file);

                    cropper.destroy();
                    cropper = new Cropper(image, options);
                    container.find('img').val(null);

                    container.find('button[data-method="zoom-out"], button[data-method="zoom-in"], button[data-method="save"], button[data-method="preview"]')
                        .attr('disabled', null);
                    container.find('image').removeClass('empty');
                } else {
                    global_notification('warning', 'You may only upload the following image types: JPG, PNG, GIF.');
                }
            }
        });

        $('[data-method="zoom-in"]').on('click', function () {
            cropper.zoom(0.1);
        });

        $('[data-method="zoom-out"]').on('click', function () {
            cropper.zoom(-0.1);
        });

        $('[data-method="preview"]').on('click', function () {
            data = cropper.getCroppedCanvas({
                width: 480,
                height: 270,
                fillColor: '#ffffff'
            });

            $('#getCroppedCanvasModal').modal().find('.modal-body').html(data);

        });

        $('[data-method="save"]').on('click', function () {
            var container = $(this).closest('.avatar-container');

            cropper.getCroppedCanvas().toBlob(function (blob) {
                var formData = new FormData();
                formData.append('avatar', blob);

                $.ajax({
                    url: '/user/avatar/store/',
                    method: "POST",
                    data: formData,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        container.find('img').attr('src', data['path']);
                        var image = document.getElementById(container.find('img').attr('id'));

                        cropper.destroy();
                        cropper = new Cropper(image, options);
                        container.find('img').val(null);

                        global_notification('success', 'Your avatar has been saved. You may need to refresh your browser to see changes.');
                    },
                    error: function (xhr) {
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            });
        });
    });
}